import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '外部项目维度对象',
    type: 'DO_1',
}
